// Hábitos e Autocuidado — páginas 40 (hábitos por elemento), 41 (manhã),
// 42 (noite) e 43 (checklist diário). Fiel ao PDF.

export const HABITS_BY_ELEMENT = [
  { id: "madeira", elemento: "madeira", qualidade: "Movimento e direção", orgaos: "Fígado e Vesícula Biliar", habitos: ["alongar", "caminhar", "planejar com flexibilidade", "respirar antes de reagir"], sourcePages: [40], source: { pdfPage: 42, printedPage: "40" } },
  { id: "fogo", elemento: "fogo", qualidade: "Presença e alegria", orgaos: "Coração, Intestino Delgado, Pericárdio e Triplo Aquecedor", habitos: ["reduzir telas à noite", "cultivar vínculos", "sorrir com leveza", "dormir melhor"], sourcePages: [40], source: { pdfPage: 42, printedPage: "40" } },
  { id: "terra", elemento: "terra", qualidade: "Nutrição e estabilidade", orgaos: "Estômago e Baço-Pâncreas", habitos: ["comer com calma", "manter horários", "escolher alimentos mornos", "pausar entre tarefas"], sourcePages: [40], source: { pdfPage: 42, printedPage: "40" } },
  { id: "metal", elemento: "metal", qualidade: "Respiração e desapego", orgaos: "Pulmão e Intestino Grosso", habitos: ["respirar profundo", "organizar espaços", "soltar excessos", "cuidar da pele"], sourcePages: [40], source: { pdfPage: 42, printedPage: "40" } },
  { id: "agua", elemento: "agua", qualidade: "Descanso e reserva", orgaos: "Rins e Bexiga", habitos: ["dormir bem", "aquecer lombar e pés", "beber água", "respeitar limites"], sourcePages: [40], source: { pdfPage: 42, printedPage: "40" } },
];

export const HABITS_HOW_TO = [
  "Escolha um elemento.",
  "Defina uma ação.",
  "Observe o efeito.",
  "Anote padrões.",
  "Ajuste com calma.",
];

export const HABITS_SIDE_CARDS = {
  comecePequeno: {
    titulo: "Comece pequeno",
    texto: "Escolha uma ação por dia. O simples repetido com constância transforma a rotina.",
  },
  semExcesso: {
    titulo: "Sem excesso",
    texto: "Autocuidado não deve virar cobrança. Observe seu corpo com gentileza.",
  },
  frase: "“Equilíbrio nasce quando pequenas escolhas começam a conversar com o corpo.”",
};
export const HABITS_SOURCE = { pdfPage: 42, printedPage: "40" };

export const MORNING_ROUTINE = [
  { titulo: "Acorde sem pressa", texto: "Antes de pegar o celular, respire fundo três vezes." },
  { titulo: "Observe seu corpo", texto: "Note sono, respiração, digestão, humor e energia." },
  { titulo: "Hidrate-se", texto: "Beba água em temperatura agradável." },
  { titulo: "Movimente-se", texto: "Faça alongamentos leves ou uma caminhada curta." },
  { titulo: "Nutra-se com calma", texto: "Escolha uma refeição simples e coma com atenção." },
  { titulo: "Defina uma intenção", texto: "Escolha uma palavra para guiar seu dia." },
];
export const MORNING_EXTRAS = {
  evite: "Acordar correndo pode dificultar a percepção dos sinais do corpo.",
  lembrete: "Não precisa fazer tudo. Escolha um ritual pequeno e repita com gentileza.",
  checkIn: ["Sono", "Energia", "Humor", "Digestão", "Respiração"],
  frase: "O jeito como você começa o dia ensina o corpo a encontrar ritmo.",
};
export const MORNING_SOURCE = [41];

export const EVENING_ROUTINE = [
  { titulo: "Reduza o ritmo", texto: "Diminua luzes, barulho e telas." },
  { titulo: "Revise o dia", texto: "Observe sem julgamento o que seu corpo mostrou." },
  { titulo: "Prepare uma bebida morna", texto: "Escolha algo simples e adequado à sua rotina." },
  { titulo: "Solte tensões", texto: "Alongue pescoço, ombros, lombar e respire devagar." },
  { titulo: "Anote um padrão", texto: "Registre sono, emoção, digestão ou energia." },
  { titulo: "Acolha o descanso", texto: "Permita que o corpo entre em pausa." },
];
export const EVENING_EXTRAS = {
  evite: "Pensamentos acumulados podem manter o corpo em alerta.",
  lembrete: "Descanso também é prática. Dormir bem sustenta energia, clareza e equilíbrio.",
  checkIn: ["Telas", "Respiração", "Emoção", "Sono", "Gratidão"],
  frase: "A noite ensina o corpo a soltar o que já cumpriu seu papel.",
};
export const EVENING_SOURCE = [42];

export const CHECKLIST = {
  manha: ["Bebi água", "Observei meu corpo", "Respirei com calma", "Fiz movimento leve", "Comi com atenção"],
  dia: ["Percebi minha emoção predominante", "Fiz uma pausa", "Evitei excessos", "Prestei atenção na digestão", "Anotei um sinal importante"],
  noite: ["Reduzi telas", "Preparei o descanso", "Soltei tensões", "Registrei padrões", "Agradeci algo simples"],
};
export const CHECKLIST_ESCALAS = ["Energia do dia", "Qualidade do sono", "Digestão"];
export const CHECKLIST_TEXTOS = ["Emoção predominante", "Sinal do corpo que mais apareceu"];
export const CHECKLIST_SOURCE = [43];
export const CHECKLIST_NOTE =
  "Use este checklist como apoio de observação. Ele não precisa ser preenchido perfeitamente; a intenção é perceber padrões com gentileza. Se algum item não aconteceu, apenas observe. Amanhã é uma nova oportunidade.";

// Página física 38 / impressa 36: Como observar seus padrões na prática
export const PADROES_PAGINA_38 = {
  titulo: "Como observar seus padrões na prática",
  subtitulo: "Transforme sinais soltos em percepção consciente.",
  intro:
    "Depois de conhecer os órgãos, comece a observar repetições. Um sinal isolado nem sempre revela muito. Mas quando ele aparece junto com horário, emoção, alimentação, sono e rotina, começa a formar um padrão.",
  destaque: {
    linha1: "Observar não é se diagnosticar.",
    linha2: "É aprender a escutar o corpo com mais consciência.",
  },
  oQueObservar: {
    titulo: "O que observar",
    itens: ["Horário", "Emoção", "Alimentação", "Sono", "Movimento", "Intensidade"],
  },
  comoAnotar: {
    titulo: "Como anotar",
    texto:
      "Registre o sinal, quando apareceu, o que aconteceu antes e se melhorou ou piorou com alguma mudança simples na rotina.",
  },
  lembreSe: {
    titulo: "Lembre-se",
    texto:
      "Na MTC, o corpo é visto como um conjunto de relações. Quanto mais contexto você observa, mais clara fica a conversa entre corpo, mente e rotina.",
  },
  source: { pdfPage: 38, printedPage: "36" },
};

// Os 6 pontos do padrão (Página física 38 / impressa 36)
export const OBSERVE_POINTS = [
  { n: 1, titulo: "Frequência", texto: "acontece uma vez ou se repete?" },
  { n: 2, titulo: "Intensidade", texto: "leve, moderado ou forte?" },
  { n: 3, titulo: "Horário", texto: "surge sempre no mesmo período?" },
  { n: 4, titulo: "Emoção", texto: "que sentimento estava presente?" },
  { n: 5, titulo: "Contexto", texto: "houve mudança na alimentação, sono ou estresse?" },
  { n: 6, titulo: "Evolução", texto: "está melhorando, igual ou piorando?" },
];


export const CHANGES_TIME = [
  { periodo: "1 Dia", texto: "Observe sem pressa. Anote horário, emoção, alimentação e descanso." },
  { periodo: "1 Semana", texto: "Procure repetições: o mesmo período, o mesmo gatilho ou o mesmo tipo de desconforto." },
  { periodo: "1 Mês", texto: "Veja ciclos maiores: rotina, sono, emoções, digestão e fases de maior sensibilidade." },
];
export const CHANGES_QUESTIONS = [
  "Aparece em qual horário?",
  "Melhora com descanso?",
  "Vem junto de qual emoção?",
  "Há tensão no mesmo lugar?",
  "Piora com algum alimento?",
  "Qual órgão aparece no guia?",
];
export const CHANGES_NEXT = ["Anotar", "Comparar", "Consultar o órgão", "Ajustar hábitos", "Observar resposta"];
export const CHANGES_SOURCE = [46];

// Antes de continuar (pág. física 13 / impressa 11)
export const ANTES_DE_CONTINUAR = {
  titulo: "Antes de procurar respostas no seu corpo, permita-se escutá-lo.",
  subtitulo: "Seu corpo nunca fala por acaso.",
  texto1: "Durante anos, talvez você tenha aprendido a ignorar pequenos sinais. A dor de cabeça virou rotina. O cansaço passou a ser “normal”. A má digestão foi tratada como algo comum. A ansiedade virou parte do dia.",
  texto2: "Mas o corpo quase sempre tenta conversar antes de precisar gritar. Cada sensação pode ser um convite para desacelerar, observar seus hábitos e refletir sobre como você tem cuidado de si.",
  destaque: "Nem todo sintoma significa uma doença. Nem toda dor tem origem apenas no corpo. Assim como nem toda emoção permanece apenas na mente.",
  conexoes: ["Sono", "Alimentação", "Respiração", "Emoções", "Movimento", "Descanso", "Relacionamentos"],
  conexoesNota: "Tudo isso influencia a forma como nos sentimos.",
  perguntas: [
    "Como tenho tratado meu corpo?",
    "O que mudou na minha rotina?",
    "Como estão minhas emoções?",
    "Tenho respeitado meus limites?",
  ],
  orientacoes: [
    "Leia com curiosidade.",
    "Observe com calma.",
    "Experimente pequenas mudanças.",
  ],
  mensagemFinal: "Seu corpo não é seu inimigo. Ele está tentando ajudá-lo. Aprenda a escutá-lo com respeito.",
  source: { pdfPage: 13, printedPage: "11" },
};

// Seu corpo fala — Encerramento (pág. física 51 / impressa 49)
export const SEU_CORPO_FALA = {
  titulo: "Seu corpo fala",
  subtitulo: "Agora você tem um mapa para ouvir com mais presença.",
  texto1: "Ao longo deste guia, você viu que a Medicina Tradicional Chinesa observa o corpo como uma rede de relações: órgãos, emoções, hábitos, alimentos, horários e energia.",
  texto2: "Use esse conhecimento com calma. Volte às páginas sempre que precisar, compare seus sinais, experimente pequenos ajustes e observe como seu corpo responde.",
  destaque: "Cuidar de si é aprender a perceber antes de precisar corrigir.",
  lembretes: [
    "Observe com gentileza",
    "Escolha mudanças simples",
    "Procure orientação profissional quando necessário",
  ],
  source: { pdfPage: 51, printedPage: "49" },
};

// Página física 3 / impressa 1: Boas-vindas ao Corpo Conectado
export const BEM_VINDO = {
  titulo: "Bem-vindo ao Corpo Conectado",
  subtitulo: "Seu corpo fala o tempo todo.",
  textoIntro:
    "Dor, cansaço, digestão lenta, ansiedade, insônia ou respiração difícil podem ser interpretados de diferentes formas conforme a abordagem utilizada. Neste guia você conhecerá a visão da Medicina Tradicional Chinesa (MTC) sobre essas conexões e aprenderá hábitos simples tradicionalmente utilizados para promover equilíbrio e bem-estar.",
  oQueEMTC: {
    titulo: "O que é a Medicina Tradicional Chinesa?",
    texto1: "A Medicina Tradicional Chinesa é um sistema de cuidados desenvolvido ao longo de muitos séculos.",
    texto2: "Ela observa o corpo de forma integrada, considerando órgãos, emoções, alimentação, sono e estilo de vida conectados.",
    ressalva: "Importante: os conceitos apresentados neste guia pertencem à tradição da MTC e podem diferir das explicações da medicina convencional.",
  },
  citacao: "Quando compreendemos os sinais do corpo, aprendemos a cuidar dele antes que ele precise gritar.",
  comoInterpretar: [
    { label: "Função", desc: "Papel do órgão na MTC." },
    { label: "Sinais", desc: "Sintomas relacionados." },
    { label: "Autocuidado", desc: "Hábitos e recursos naturais inspirados na MTC." },
    { label: "Curiosidade", desc: "Um fato interessante sobre essa tradição." },
    { label: "Atenção", desc: "Quando é importante procurar avaliação profissional." },
  ],
  source: { pdfPage: 3, printedPage: "1" },
};

// Página física 4 / impressa 2: Como aproveitar este guia
export const COMO_APROVEITAR = {
  titulo: "Como aproveitar este guia",
  passos: [
    { passo: "Passo 1", texto: "Escolha um sintoma", link: "/sintomas" },
    { passo: "Passo 2", texto: "Descubra quais órgãos podem estar relacionados na visão da MTC.", link: "/sintomas" },
    { passo: "Passo 3", texto: "Leia a explicação.", link: "/orgaos" },
    { passo: "Passo 4", texto: "Conheça hábitos, alimentos e chás tradicionalmente utilizados para apoiar o equilíbrio.", link: "/autocuidado" },
    { passo: "Passo 5", texto: "Observe como seu corpo responde ao longo do tempo.", link: "/registros" },
  ],
  oQueEncontrara: [
    { campo: "Função", desc: "Papel do órgão na MTC." },
    { campo: "Emoção relacionada", desc: "Sentimentos ligados ao órgão." },
    { campo: "Principais sinais", desc: "Sinais de desequilíbrio mais comuns." },
    { campo: "Alimentos", desc: "Alimentos que apoiam ou prejudicam." },
    { campo: "Chá recomendado", desc: "Chá e plantas que auxiliam." },
    { campo: "Melhor horário", desc: "Horário de maior atividade do órgão." },
    { campo: "Curiosidade", desc: "Fato interessante sobre esse órgão." },
    { campo: "Hábito do dia", desc: "Pequena ação diária para equilibrar." },
    { campo: "Quando procurar avaliação profissional", desc: "Sinais de alerta importantes." },
  ],
  esteGuiaE: [
    "Um material educativo.",
    "Um guia de consulta.",
    "Inspirado na Medicina Tradicional Chinesa.",
    "Voltado ao autocuidado consciente.",
  ],
  esteGuiaNaoE: [
    "Um diagnóstico.",
    "Um tratamento médico.",
    "Uma prescrição.",
    "Um substituto para consultas com profissionais de saúde.",
  ],
  citacao: "Conhecimento gera consciência. Consciência transforma hábitos. Hábitos transformam vidas.",
  source: { pdfPage: 4, printedPage: "2" },
};

